import { breakpoints } from '@bnnvara/breakpoints';
import { ThemeIcon } from '@bnnvara/icons/src/components/UserInterfaceIcons/Theme';
import { Text } from '@bnnvara/typography';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import { typography, space } from 'styled-system';

const Small = css`
  div {
    font-size: 14px;
  }
  svg {
    height: 24px;
    width: 9px;
  }
`;

const StyledThemeTag = styled.span`
  display: inline-flex;
  align-items: center;
  text-transform: uppercase;
  cursor: pointer;
  div {
    color: ${({ color }) => color};
    font-weight: 700;
  }
  &:hover {
    div {
      color: ${({ colorHover }) => colorHover};
    }
    svg {
      * {
        fill: ${({ colorHover }) => colorHover};
      }
    }
  }
  &:active {
    div {
      color: ${({ colorActive }) => colorActive};
    }
    svg {
      * {
        fill: ${({ colorActive }) => colorActive};
      }
    }
  }

  ${breakpoints.md} {
    padding: 4px 0px;
    border-radius: 2px;
  }

  svg {
    height: 24px;
    width: 4px;
    padding-right: 4px;

    * {
      fill: ${({ color }) => color};
    }

    ${breakpoints.md} {
      margin-top: 1px;
      height: 24px;
      width: 4px;
      padding-right: 8px;
    }
  }

  ${({ size }) => size === 'sm' && Small};
  ${space}
  ${typography}
`;

export const ThemeTag = ({
  children,
  color,
  colorHover,
  colorActive,
  colorVisited,
  size,
  href,
  ...props
}) => {
  return (
    <Link href={href}>
      <StyledThemeTag
        color={color}
        colorHover={colorHover}
        colorActive={colorActive}
        colorVisited={colorVisited}
        size={size}
        {...props}
      >
        <ThemeIcon />
        <Text>{children}</Text>
      </StyledThemeTag>
    </Link>
  );
};

ThemeTag.defaultProps = {
  size: 'md',
};

ThemeTag.propTypes = {
  children: PropTypes.node.isRequired,
  iconLeft: PropTypes.node,
  color: PropTypes.string,
  colorHover: PropTypes.string,
  colorActive: PropTypes.string,
  colorVisited: PropTypes.string,
  href: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md']),
};
